import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function InstallmentsPage(){return <ExtendedModulePage moduleKey="installments"/>}
